export default __webpack_public_path__ + "static/media/face_1_23.dee6a848.png";